module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVUlEQVQ4jZ3Vu04bQRTG8Z9HlisqqhAJRJGCvABNKqdIySXQ8QogZKrkCQINBIkXoMfcQg00NEgpqKFAoEBHHyMBxc6Kxdqb+aSVjvZ85z8zO7NnGt/mO3LUwhRm8AUf8R//8Bd7OMRjf2EzBzaL3xjLGWQiPgu4wgr+ZE0hEzfwC90cWJ4+4SDWNPJmuImlGqCsGviBobQ2neH3d8CyWsRcCmxho0bRNT5juyC/jlYzkqu+2TXaMf5a4BnDXJDsal3YCUZLvLMBkwPAxisGnwz4UJB8GBAGIwG9EsNzDcgbBdwX5IZxGuO2ZPlVug+4KDGMS5ZbF3oesF9h6ofelnj3AnYqTFloE8cFnlt0m5JN6URwFfSyJN9BL/2Xu9iqAJZpKzLetK9lrBr8qKzFWv3AJ/zEPG5qgK4wLWlfT+nLvI69i6NonvZ6BcAdziQn40DOFfAC5pREfH2ve0wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-left-dark.png
// module id = D92t
// module chunks = 5